import React, { useState } from 'react';

// Components
import Modal from '../../UI/Modal/Modal';

// Other
import DialogFilterPolls from '../DialogFilterPolls/DialogFilterPolls';

// Interfaces
import { InquiryTypes } from '../../../services/Poll';
import ButtonFilter from '../../Helpers/ButtonFilter/ButtonFilter';
import Icon from '../../UI/Icon/Icon';
interface Props {
    defaultTypePoll: InquiryTypes[]
    defaultSeeAnswered: boolean
    defaultFromDate: moment.Moment | null
    defaultToDate: moment.Moment | null
    onConfirm: (type: InquiryTypes[], seeOnlyAnswered: boolean, fromDate: moment.Moment | null, toDate: moment.Moment | null) => void
}

const FilterButtonPolls: React.FC<Props> = ({ defaultTypePoll, defaultSeeAnswered, defaultFromDate, defaultToDate, onConfirm }) => {


    const [showDialog, setShowDialog] = useState(false);

    const filterActive = defaultTypePoll.length !== 0 || defaultSeeAnswered === true || defaultFromDate !== null || defaultToDate !== null;

    return (
        <>
            <button onClick={() => setShowDialog(true)}>
                <Icon>
                    <ButtonFilter filterActive={filterActive} style={{ color: '#cacaca' }} />
                </Icon>
            </button>
            <Modal show={showDialog} setShowModal={setShowDialog}>
                <DialogFilterPolls
                    defaultTypePoll={defaultTypePoll}
                    defaultSeeAnswered={defaultSeeAnswered}
                    defaultFromDate={defaultFromDate}
                    defaultToDate={defaultToDate}
                    closeModal={() => setShowDialog(false)}
                    onConfirm={onConfirm}
                />
            </Modal>
        </>
    );
};

export default FilterButtonPolls;